<template>
  <base-modal
    :id="id"
    :key="id"
    v-bind="$attrs"
    :show="show"
    class="confirm-toast"
    @closed="closed"
  >
    <div class="py-5 my-1 px-4 text-center">
      <base-heading
        :class="{
          'mb-4': showActions,
          'mb-0': !showActions
        }"
        style="word-break: break-word"
      >
        {{ message }}
      </base-heading>
      <slot />
      <div
        v-if="showActions"
        class="d-flex justify-content-center"
        :class="{'flex-row-reverse' : reverse}"
      >
        <slot name="actions">
          <template v-for="action in actions">
            <base-button
              v-if="(!action.positive && showCancel) || action.positive"
              :key="`action_${action.event}`"
              class="actions"
              :inverse="action.positive"
              :class="`${!action.positive ? 'mx-4' : ''} ${dialogException ? 'dialog-exception' : '' }`"
              @click.native="$emit(action.event)"
            >
              {{ action.text }}
            </base-button>
          </template>
        </slot>
      </div>
    </div>
  </base-modal>
</template>
<script>
export default {
  name: 'BaseConfirmDialog',
  inheritAttrs: false,
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    showCancel: {
      type: Boolean,
      default: true,
    },
    positiveText: {
      type: String,
      default: 'Accept',
    },
    negativeText: {
      type: String,
      default: 'Cancel',
    },
    message: {
      type: String,
      default: 'Are you sure?',
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    show: {
      type: Boolean,
      default: true,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    dialogException: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      id: `confirm-dialog-${Date.now()}`,
      showModal: true,
    };
  },
  computed: {
    actions() {
      return [
        { positive: false, text: this.negativeText, event: 'cancelled' },
        { positive: true, text: this.positiveText, event: 'confirmed' },
      ];
    },
  },
  watch: {
    showModal(newval) {
      if (newval) {
        this.refreshId();
      }
    },
  },
  mounted() {
    this.refreshId();
  },
  methods: {
    closed() {
      this.$emit('cancelled');
      this.$emit('closed');
    },
    refreshId() {
      this.id = `confirm-dialog-${Date.now()}`;
    },
  },
};
</script>
<style lang="scss"
  scoped>
.confirm-toast {
  ::v-deep .modal-dialog {
    justify-content: center;
    max-width: 458px !important;
    top: 35%;
    transform: translateY(calc(-50%));
    margin-top: 0;

    .modal-content {
      width: 458px !important;
      border: none !important;
      border-radius: 12px !important;

      .modal-body {
        padding: 0px !important;

        .base-button {
          padding: 11px 10px;
          border: none;

          &--inverse {
            padding: 11px 40px;
          }
        }
      }
    }
  }
}

::v-deep .actions {
  font-family: $font-family-sans-serif;
}
::v-deep button.close {
  padding-right: 20px !important;
  padding-top: 7px !important;
}
</style>
